module.exports = __webpack_public_path__ + "static/img/b7.bfc3123.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/b7.png
// module id = 3usO
// module chunks = 1